// 画像プレビュー切替（マウス/キーボード/タッチ対応）— イベント委譲で安定
(function () {
  function findCard(el){ return el.closest('.ttz-card'); }
  function getImg(card){ return card ? card.querySelector('.ttz-card__img') : null; }
  function getMain(img){
    if (!img) return null;
    return {
      src:    img.getAttribute('data-main-src')    || img.getAttribute('src'),
      srcset: img.getAttribute('data-main-srcset') || img.getAttribute('srcset') || '',
      sizes:  img.getAttribute('data-main-sizes')  || img.getAttribute('sizes')  || ''
    };
  }
  function showPreview(img, previewSrc){
    if (!img || !previewSrc) return;
    const pre = new Image();
    img.style.opacity = '0.3';
    pre.onload = () => {
      // 強制的にこの1枚を使わせる
      img.src = previewSrc;
      img.srcset = previewSrc + ' 800w';
      img.sizes = '100vw';
      img.style.opacity = '1';
    };
    pre.src = previewSrc;
  }
  function resetPreview(img){
    if (!img) return;
    const main = getMain(img);
    if (!main) return;
    const pre = new Image();
    img.style.opacity = '0.3';
    pre.onload = () => {
      img.src = main.src;
      img.srcset = main.srcset;
      img.sizes = main.sizes;
      img.style.opacity = '1';
    };
    pre.src = main.src;
  }

  // mouse/focus
  document.addEventListener('mouseover', (e) => {
    const link = e.target.closest('.ttz-swatch__link'); if (!link) return;
    const img  = getImg(findCard(link)); if (!img) return;
    const src  = link.getAttribute('data-swatch-img');
    if (src) showPreview(img, src);
  });
  document.addEventListener('mouseout', (e) => {
    const link = e.target.closest('.ttz-swatch__link'); if (!link) return;
    const img  = getImg(findCard(link)); if (!img) return;
    resetPreview(img);
  });
  document.addEventListener('focusin', (e) => {
    const link = e.target.closest('.ttz-swatch__link'); if (!link) return;
    const img  = getImg(findCard(link)); if (!img) return;
    const src  = link.getAttribute('data-swatch-img');
    if (src) showPreview(img, src);
  });
  document.addEventListener('focusout', (e) => {
    const link = e.target.closest('.ttz-swatch__link'); if (!link) return;
    const img  = getImg(findCard(link)); if (!img) return;
    resetPreview(img);
  });

  // touch: 1回目でプレビュー、2回目で遷移
  document.addEventListener('touchstart', (e) => {
    const link = e.target.closest('.ttz-swatch__link'); if (!link) return;
    const card = findCard(link);
    const img  = getImg(card); if (!img) return;
    const preview = link.getAttribute('data-swatch-img');
    if (!preview) return;
    // すでに同じプレビューなら許可、違えばプレビューだけ表示
    if (img.currentPreview !== preview) {
      e.preventDefault();
      img.currentPreview = preview;
      showPreview(img, preview);
      setTimeout(() => { img.currentPreview = null; resetPreview(img); }, 1500);
    }
  }, { passive: false });

  // Shopify セクション再読み込みでも動く（委譲なので再バインド不要）
  document.addEventListener('shopify:section:load', () => {});
})();
